import styled from 'styled-components';

export const ExtendedBackgroundContainer = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;
  gap: 20px;
  overflow: hidden;
  height: auto;
  min-height: 100px;
  width: 100%;
  z-index: 0;

  @media (min-width: 1024px) {
    min-height: 150px;
  }

  &:before {
    border-radius: 100% 100% 0 0;
    position: absolute;
    background: ${(props) => props.$background ?? 'white'};
    bottom: -700px;
    right: -300px;
    left: -300px;
    content: '';
    top: 0;
    z-index: -10;

    @media (max-width: 1024px) {
      right: -350px;
      left: -350px;
    }
  }
`;
